import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {UtilsService} from "./utils.service";
import {AbstractFilterCode, AllInsurancesFilter, Tarification} from "@icure/api";
import {GROUP_ID_TEMPLATE} from "./tools.service";
import {
  COMPLETED,
  ERROR, WAITING
} from "../../app/private/database/database-group-info/dialogs/code-importation-dialog/code-importation-dialog.component";
import {AbstractFilterInsurance} from "@icure/api/icc-api/model/AbstractFilterInsurance";

@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  constructor(
    private api: ApiService,
    private utils: UtilsService
  ) {
  }

  public async getInsuranceByIds(groupId: string, insuranceIds?: string[]) {
    return this.api.insuranceApi.getInsurancesInGroup(groupId, insuranceIds ?? []);
  }

  public async getInsuranceIds(groupId: string, filter: AbstractFilterInsurance) {
    return this.api.insuranceApi.matchInsurancesByInGroup(groupId, filter);
  }

  public async injectInsuranceIntoDb(targetGroup: string): Promise<{
    injectedCodes: number;
    updatedCodes: number;
    status: string;
  }> {
    const filter: AbstractFilterInsurance = new AbstractFilterInsurance(new AllInsurancesFilter({}));
    const idsFromTemplate: string[] = await this.getInsuranceIds(GROUP_ID_TEMPLATE, filter) ?? [];
    const existingIdsInTargetDb: string[] = await this.getInsuranceIds(targetGroup, filter) ?? [];
    let injectedInsurances: number = 0;
    let updatedInsurances: number = 0;
    if (idsFromTemplate?.length > 0) {
      for (const chunckedIds of this.utils.chunkArray(idsFromTemplate, 100)) {
        try {
          const insurancesFromTemplate: Tarification[] = await this.getInsuranceByIds(GROUP_ID_TEMPLATE, chunckedIds);
          let insurancesToInject: Tarification[] = insurancesFromTemplate.filter(c => !existingIdsInTargetDb.includes(c.id!));
          let insurancesToUpdate: Tarification[] = insurancesFromTemplate.filter(c => existingIdsInTargetDb.includes(c.id!));
          injectedInsurances += insurancesToInject?.length ?? 0;
          updatedInsurances += insurancesToUpdate?.length ?? 0;
          if (insurancesToInject?.length) {
            insurancesToInject.map(code => delete code.rev);
            insurancesToInject = insurancesToInject.map(code => ({
              ...code,
              type: code.type ?? 'org.taktik.icure.entities.Insurance'
            }))
            await this.api.insuranceApi.createInsurancesInGroup(targetGroup, insurancesToInject);
          }
          if (insurancesToUpdate?.length) {
            const insurancesFromTarget: Tarification[] = await this.getInsuranceByIds(targetGroup, insurancesToUpdate.map(c => c.id!!));
            const templateByIds: Record<string, Tarification> = Object.fromEntries(insurancesToUpdate.map(c => [c.id, c]));
            const mergedInsurances: Tarification[] = insurancesFromTarget.map(targetInsurance => {
              const templateInsurance = templateByIds[targetInsurance.id!];
              if (!templateInsurance) return targetInsurance;
              const {rev, type, id, version, ...templateData} = templateInsurance;
              return {...targetInsurance, ...templateData};
            });
            await this.api.insuranceApi.modifyInsurancesInGroup(targetGroup, mergedInsurances);
          }
        } catch (e) {
          return {injectedCodes: injectedInsurances, updatedCodes: updatedInsurances, status: ERROR};
        }
      }
      return {injectedCodes: injectedInsurances, updatedCodes: updatedInsurances, status: COMPLETED};
    }
    return {injectedCodes: 0, updatedCodes: 0, status: WAITING};
  }
}
